// extracted by mini-css-extract-plugin
export var career = "career-module--career--2gBXC";
export var careerContainer = "career-module--career-container--uoy5j";
export var careerDescription = "career-module--career-description--6q7AV";
export var careerLink = "career-module--career-link--D5sxz";
export var careerLocation = "career-module--career-location--AJ5S5";
export var careerTitle = "career-module--career-title--Hh1jR";